module.exports = __webpack_public_path__ + "img/battery-mk2-equipment.9bb1a22e.png";